import axios from 'axios';

const loadMoreNews = () => {
	const button = document.querySelector('.c-newsSection__loadMoreBtn');

	if (typeof button !== 'undefined' && button !== null) {
		button.addEventListener('click', e => {
			e.preventDefault();

			const adminUrl = window.norsjoGlob.adminUrl;
			const newsContainer = document.querySelector('.c-newsSectionGrid');
			const buttonContainer = button.closest('.c-newsSection__footer');

			const currentPage = newsContainer.dataset.page;
			const maxPages = newsContainer.dataset.max;
			const filterPosts = newsContainer.dataset.filterPosts;
			const filterTerms = newsContainer.dataset.filterTerms;

			const params = new URLSearchParams();
			params.append('action', 'load_more_posts');
			params.append('current_page', currentPage);
			params.append('max_pages', maxPages);
			params.append('filter_posts', filterPosts);
			params.append('filter_terms', filterTerms);

			// Loading indication
			button.disabled = true;
			buttonContainer.classList.add('is-loading');

			axios.post(`${adminUrl}admin-ajax.php`, params).then(res => {
				// Reset loading indication
				buttonContainer.classList.remove('is-loading');
				button.disabled = false;

				// Apply data
				newsContainer.innerHTML += res.data.data;
				newsContainer.dataset.page++;

				if (newsContainer.dataset.page === newsContainer.dataset.max) {
					button.closest('.c-newsSection__footer').remove();
				}
			});
		});

		// Prevent focus styling on click
		button.addEventListener('mousedown', e => {
			e.preventDefault();
		});
	}
};

export default loadMoreNews;
